export default __webpack_public_path__ + "static/media/Social Links.26d64e23.svg";